import { useModal } from 'Hooks'

const ManageBudgetModal = ({ visible, setVisible, user, onSubmit, error }) => {
  // Hooks
  const { Modal, hide } = useModal({ identifier: 'manageteambudget', visible, setVisible })
  return (
    <Modal>
      <div className="modal-content" style={{ maxWidth: 800 }}>
          <div className="modal-header">
            <h3 className="modal-title fs-5 text-center" id="exampleModalLabel">
              Manage team member budget
            </h3>
          </div>
          <div className="modal-body">
          </div>
      </div>
    </Modal>
  )
}
export default ManageBudgetModal
